import { AgGridVue } from 'ag-grid-vue'
import { loading, toast } from '@/shared/utils/UIHelper'
import Forms from '@/components/forms/Forms.vue'
import COPOficialWorkModelRepository from '@/shared/http/repositories/pci/copoficialworkmodel'
import COPOficialWorkObsRepository from '@/shared/http/repositories/pci/copoficialworkobs'
import WorkRepository from '@/shared/http/repositories/business/work'
import moment from 'moment'
import gridMixin from '../../mixins/gridMixin'
import PermissionMixin from '@/store/module/permission/mixin'
import roles from '@/shared/utils/roles'
import DateCopCellRenderer from './DateCopCellRenderer.vue'
import DateEditor from '../DateEditor.vue'
import VuePdfApp from 'vue-pdf-app'
import 'vue-pdf-app/dist/icons/main.css'

export default {
  name: 'Cop',
  mixins: [gridMixin, PermissionMixin],
  components: {
    AgGridVue,
    Forms,
    DateCopCellRenderer,
    DateEditor,
    VuePdfApp
  },
  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      roles: roles,
      showCopPdf: false,
      showCopImg: false,
      showCopDates: false,
      showEditStatus: false,
      copDatesType: 'add',
      gridCOPService: null,
      gridCOPDoc: null,
      isObsDocUpdate: false,
      isObsServUpdate: false,
      pci: {},
      currentDataToUploadFile: null,
      copOfServData: [],
      copOfDocData: [],
      copWorkData: {},
      copPdf: null,
      copImg: [],
      changeStatusObj: null,
      pdfConfig: {
        toolbar: {
          toolbarViewerRight: {
            presentationMode: false,
            openFile: false,
            download: false,
            viewBookmark: false
          },
          toolbarViewerMiddle: {
            zoomOut: true,
            zoomIn: true,
            scaleSelectContainer: true
          }
        },
        secondaryToolbar: {
          secondaryPresentationMode: false,
          secondaryOpenFile: false,
          secondaryPrint: false,
          secondaryDownload: false,
          secondaryViewBookmark: false,
          pageRotateCw: true,
          pageRotateCcw: true,
          cursorSelectTool: false,
          cursorHandTool: false,
          scrollVertical: false,
          scrollHorizontal: false,
          scrollWrapped: false,
          spreadNone: false,
          spreadOdd: false,
          spreadEven: false,
          documentProperties: false
        }
      },
      formCOPAddDatas: {
        diasMeta: 0
      },
      copDocGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20,
        // suppressHorizontalScroll: true,
        rowGroupPanelShow: 'never',
        sideBar: null
      },
      copServGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20,
        // suppressHorizontalScroll: true,
        rowGroupPanelShow: 'never',
        sideBar: null
      },
      copOfObs: {
        id: null,
        copModeloObraID: null,
        observacaoDocumento: null,
        observacaoServico: null
      },
      copOfObsOrig: {
        id: null,
        copModeloObraID: null,
        observacaoDocumento: null,
        observacaoServico: null
      },
      copServColumnDefs: {},
      copDocColumnDefs: {},
      copDefaultColumnDefs: {
        floatingFilter: false,
        editable: false,
        suppressMovable: true,
        suppressMenu: true,
        sortable: false,
        resizable: true,
        enableRowGroup: false
      },
      copColumnTypes: {
        dateCopColumn: {
          cellEditor: 'DateEditor',
          cellRendererSelector: (params) => {
            return {
              component: 'DateCopCellRenderer',
              params: {
                value: params.value,
                na: params.data.na
              }
            }
          }
        }
      }
    }
  },
  computed: {
    isEmpty () {
      return !this.copOfServData.some(c => Boolean(c.previsao1)) && !this.copOfDocData.some(c => Boolean(c.previsao1))
    },
    copDatesTitle () {
      return this.copDatesType === 'add' ? this.$lang.PCI.COP.Dates.AddDatesTitle : this.$lang.PCI.COP.Dates.DeleteDatesTitle
    },
    canEdit () {
      return !this.readOnly && (this.hasRole(this.roles.RW_OPER_PCI_ADM) || (this.hasRole(roles.RW_OPER_PCI_COP_COORD) && !this.pci.inicioReal))
    },
    workStatus () {
      if (this.copWorkData) {
        return this.$lang.PCI.COP['Status' + this.copWorkData.status]
      }
      return ''
    }
  },
  methods: {
    show (pci) {
      this.pci = pci
      let contractReference = pci.referenciaContrato

      this.copOfDocData = []
      this.copOfServData = []

      this.copPdf = null

      loading.push()

      COPOficialWorkModelRepository.GetCop(pci.obraId)
        .then(response => {
          this.$refs.copOf.show()
          let data = response.data.data

          let copWorkId = ''

          this.copOfServData = data
            .filter(item => item.copModeloItem.copItem.tipo === 1)
            .sort((a, b) => a.copModeloItem.posicao - b.copModeloItem.posicao)
            .map(item => {
              copWorkId = item.copModeloObra.id
              return item
            })

          this.copOfDocData = data
            .filter(item => item.copModeloItem.copItem.tipo === 2)
            .sort((a, b) => a.copModeloItem.posicao - b.copModeloItem.posicao)
            .map(item => {
              copWorkId = item.copModeloObra.id
              return item
            })

          if (!copWorkId) {
            toast.warning(this.$lang.PCI.COP.NotFound)
          } else {
            COPOficialWorkObsRepository.GetObs(copWorkId)
              .then(response => {
                this.copOfObs = response.data.data && response.data.data.length
                  ? response.data.data[0]
                  : {
                    id: null,
                    copModeloObraID: copWorkId,
                    observacaoDocumento: null,
                    observacaoServico: null
                  }

                this.copOfObsOrig = Object.assign({}, this.copOfObs)

                WorkRepository.GetWork(pci.obraId)
                  .then(response => {
                    let data = response.data.data[0]

                    this.copWorkData = {
                      code: data.referencia,
                      site: data.idSite,
                      contract: contractReference,
                      subsidiarie: data.filial.sigla,
                      type: `${data.obraClassificacao.nome} - ${data.tipo}`,
                      status: data.situacao,
                      deadline: this.pci.prazo,
                      stopped: this.pci.diasParalisacao,
                      realDeadline: this.pci.prazoReal,
                      update: data.dataAcao ? moment(data.dataAcao).format('DD/MM/YYYY') : '',
                      address: `${data.endereco} - ${data.numero} - ${data.bairro} - ${data.cidade} - ${data.estado}`
                    }
                  })
                  .catch((e) => {
                    toast.error(this.$lang.Common.Alerts.Error)
                    console.log(e)
                  })
              })
              .catch((e) => {
                toast.error(this.$lang.Common.Alerts.Error)
                console.log(e)
              })
          }
        })
        .catch((e) => {
          toast.error(this.$lang.Common.Alerts.Error)
          console.log(e)
        })
        .finally(() => loading.close())
    },
    onGridCOPDocReady (params) {
      this.gridCOPDoc = params.api
    },
    onGridCOPServiceReady (params) {
      this.gridCOPService = params.api
    },
    saveDates () {
      let datesToSave = []

      if (this.copDatesType === 'delete' && this.formCOPAddDatas.tipo) {
        if (this.formCOPAddDatas.tipo === '1') {
          this.copOfServData.forEach(c => {
            c.previsao1 = null
            c.meta = null
          })
          datesToSave.push(...this.copOfServData)
          this.copServGridOptions.api.refreshCells()
        } else {
          this.copOfDocData.forEach(c => {
            c.previsao1 = null
          })
          datesToSave.push(...this.copOfDocData)
          this.copDocGridOptions.api.refreshCells()
        }
        this.showCopDates = false
      } else if (this.formCOPAddDatas.dataBase && this.formCOPAddDatas.tipo) {
        if (this.formCOPAddDatas.tipo === '1') {
          if (this.copOfServData.some(c => Boolean(c.previsao1) || Boolean(c.meta))) {
            toast.error('Já existem datas lançadas')
            return
          }
          this.copOfServData.forEach(c => {
            var data = new Date(this.formCOPAddDatas.dataBase)
            data.setDate(data.getDate() + parseInt(c.copModeloItem.dias))
            c.previsao1 = data.toISOString()
            data.setDate(data.getDate() + parseInt(this.formCOPAddDatas.diasMeta))
            c.meta = data.toISOString()
          })
          this.copServGridOptions.api.refreshCells()
          datesToSave.push(...this.copOfServData)
        } else {
          if (this.copOfDocData.some(c => Boolean(c.previsao1))) {
            toast.error('Já existem datas lançadas')
            return
          }
          this.copOfDocData.forEach(c => {
            var data = new Date(this.formCOPAddDatas.dataBase)
            data.setDate(data.getDate() + parseInt(c.copModeloItem.dias))
            c.previsao1 = data.toISOString()
          })
          this.copDocGridOptions.api.refreshCells()
          datesToSave.push(...this.copOfDocData)
        }
      }

      if (datesToSave.length === 0) return

      this.showCopDates = false

      loading.push()
      COPOficialWorkModelRepository.PostDatesCop(datesToSave)
        .then(response => {
          if (response.data.code > 0) {
            if (response.data.code === 204) {
              toast.error(this.$lang.PCI.COP.DifferentMounting)
              this.$emit('hide')
              return
            }

            if (this.formCOPAddDatas.tipo === '1') {
              this.copOfServData = response.data.data.filter(item => item.copModeloItem.copItem.tipo === 1)
            } else {
              this.copOfDocData = response.data.data.filter(item => item.copModeloItem.copItem.tipo === 2)
            }
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }

          this.$emit('update')
        })
        .catch(err => {
          console.log(err.message)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onEdit (params) {
      COPOficialWorkModelRepository.PostDatesCop([params.data])
        .then(response => {
          if (response.data.code > 0) {
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => {
          console.log(err.message)
          toast.error(this.$lang.Common.Alerts.Error)
        })
    },
    addDates () {
      this.showCopDates = true
      this.copDatesType = 'add'
    },
    deleteDates () {
      this.showCopDates = true
      this.copDatesType = 'delete'
    },
    printCop () {
      loading.push()
      COPOficialWorkModelRepository.PrintCop(this.pci.obraId)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})

            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)

            // Alex pediu para imprimir em outra aba... a opção é abrir no mode de visualização de PDF
            // Caso queira volvar, o código está abaixo.
            // ---------------------------------------------------------------------------------------
            // const url = URL.createObjectURL(blob)
            // const iframe = document.createElement('iframe')
            // iframe.style.display = 'none'
            // iframe.src = url
            // const printDiv = document.getElementById('printDiv')
            // printDiv.innerHTML = ''
            // printDiv.appendChild(iframe)
            // iframe.contentWindow.print()
          }
        })
        .finally(() => loading.close())
    },
    cancelDocObs () {
      this.isObsDocUpdate = false
      this.copOfObs.observacaoDocumento = this.copOfObsOrig.observacaoDocumento
      this.copOfObs.observacaoDocumentoAdd = null
    },
    cancelServObs () {
      this.isObsServUpdate = false
      this.copOfObs.observacaoServico = this.copOfObsOrig.observacaoServico
      this.copOfObs.observacaoServicoAdd = null
    },
    saveDocObs () {
      var copOfObs = Object.assign({}, this.copOfObsOrig)
      copOfObs.observacaoDocumento = this.copOfObs.observacaoDocumento ? this.copOfObs.observacaoDocumento + '\n\n' : ''

      if (this.copOfObs.observacaoDocumentoAdd) {
        copOfObs.observacaoDocumento = '|' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString() + ' - ' + this.$store.state.auth.userInfo.nome + '|\n' + this.copOfObs.observacaoDocumentoAdd
      }

      copOfObs.id = this.copOfObs.id || '00000000-0000-0000-0000-000000000000'

      loading.push()
      COPOficialWorkObsRepository.UpdateObs(this.pci.obraId, copOfObs)
        .then(response => {
          if (response.data.code > 0) {
            this.isObsDocUpdate = false
            this.copOfObsOrig = response.data.data[0]
            this.copOfObs = Object.assign({}, this.copOfObsOrig)
          }
        })
        .finally(() => loading.close())
    },
    saveServObs () {
      var copOfObs = Object.assign({}, this.copOfObsOrig)
      copOfObs.observacaoServico = this.copOfObs.observacaoServico ? this.copOfObs.observacaoServico + '\n\n' : ''

      if (this.copOfObs.observacaoServicoAdd) {
        copOfObs.observacaoServico += '|' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString() + ' - ' + this.$store.state.auth.userInfo.nome + '|\n' + this.copOfObs.observacaoServicoAdd
      }

      copOfObs.id = this.copOfObs.id || '00000000-0000-0000-0000-000000000000'

      loading.push()
      COPOficialWorkObsRepository.UpdateObs(this.pci.obraId, copOfObs)
        .then(response => {
          if (response.data.code > 0) {
            this.isObsServUpdate = false
            this.copOfObsOrig = response.data.data[0]
            this.copOfObs = Object.assign({}, this.copOfObsOrig)
          }
        })
        .finally(() => loading.close())
    },
    onShowEditStatus () {
      this.changeStatusObj = {
        obraID: this.pci.obraId,
        situacao: this.copWorkData.status,
        data: new Date().toISOString().substring(0, 10)
      }
      this.showEditStatus = true
    },
    onChangeStatus (event) {
      WorkRepository.PutStatus(this.changeStatusObj)
        .then(response => {
          if (response.data.code > 0) {
            const current = this.copWorkData.status
            this.copWorkData.status = response.data.data.situacao
            this.copWorkData.update = new Date(response.data.data.dataAcao).toLocaleDateString()

            var obs = this.copOfObs.observacaoServico ? this.copOfObs.observacaoServico + '\n' : ''
            const date = new Date()
            const changeStatusDate = new Date(this.changeStatusObj.data + 'T00:00')

            obs += `${date.toLocaleDateString()} - ${date.toLocaleTimeString()} - ${this.$store.state.auth.userInfo.nome}\n`
            obs += `Alteração da situação da obra de [${this.$lang.PCI.COP['Status' + current].toUpperCase()}] para [${this.$lang.PCI.COP['Status' + this.copWorkData.status].toUpperCase()}] em ${changeStatusDate.toLocaleDateString()}`

            this.copOfObs.observacaoServico = obs
            this.changeStatusObj = null

            this.saveServObs()
          } else {
            toast.error(response.data.message)
            event.bvModalEvent.preventDefault()
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
          event.bvModalEvent.preventDefault()
        })
    },
    viewCopFile (event) {
      if (event.node.data.id !== '00000000-0000-0000-0000-000000000000') {
        loading.push()

        this.showCopPdf = false
        this.showCopImg = false
        this.copPdf = null
        this.copImg = []

        COPOficialWorkModelRepository.GetCopFile(event.data.id)
          .then(response => {
            // let continueLoop = true
            let image = false

            // response.data.data.map(file => {
            //   if (continueLoop === false) {
            //     return
            //   }
            const file = response.data.data[0]
            if (file.idPDF === true) {
              this.showCopPdf = true

              const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
                const byteCharacters = atob(b64Data)
                const byteArrays = []

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                  const slice = byteCharacters.slice(offset, offset + sliceSize)

                  const byteNumbers = new Array(slice.length)
                  for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i)
                  }

                  const byteArray = new Uint8Array(byteNumbers)
                  byteArrays.push(byteArray)
                }

                const blob = new Blob(byteArrays, { type: contentType })
                return blob
              }

              const blob = new Blob([b64toBlob(file.base64)], { type: 'application/pdf' })

              this.copPdf = URL.createObjectURL(blob)
              // continueLoop = false
            } else {
              // continueLoop = false
              this.copImg.push({
                src: encodeURI(file.base64),
                type: 'image/jpeg'
              })

              image = true
            }
            // })

            this.showCopImg = image
          })
          .catch((e) => {
            console.log(e)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => loading.close())
      }
    },
    onShowImageNewWindow () {
      const file = this.copImg[0].src
      const img = `<img src="data:image/jpeg;base64,${file}" style="display:block; margin-left:auto; margin-right:auto;">`
      const popup = window.open()
      popup.document.write(img)
    },
    addFile (params) {
      this.currentNodeToUploadFile = params.node
      if (params.node.data.copModeloItem.copItem.tipo === 1) {
        this.$refs.UploadImgFile.click()
      } else {
        this.$refs.UploadPdfFile.click()
      }
    },
    removeFile (params) {
      loading.push()
      const node = params.node
      COPOficialWorkModelRepository.DeleteCopFile(node.data.copModeloObra.id, node.data.copModeloItem.id)
        .then(response => {
          // Recusa (sem perfil PCI-ADM, obra com PDR aberta) chega HTTP 200 com code no corpo.
          if (response.data.code !== 200) {
            toast.error(response.data.message || this.$lang.Common.Alerts.Error)
            return
          }
          // O item pode ter VÁRIOS anexos (imagem soma, chamado 20173) e o servidor apaga UM.
          // Zerar a lista escondia os que sobraram; tira um e deixa o reload ser a fonte de verdade.
          const anexos = (node.data.anexos || []).slice(1)
          node.setDataValue('anexos', anexos)
        })
        .catch(() => toast.error(this.$lang.Common.Alerts.Error))
        .finally(() => loading.close())
    },
    onUploadFile (event) {
      if (event.target.files && this.currentNodeToUploadFile) {
        const file = event.target.files[0]
        const node = this.currentNodeToUploadFile

        loading.push()
        this.postarAnexoCop(node, file, false)
          .finally(() => loading.close())

        this.$refs.UploadImgFile.value = ''
        this.$refs.UploadPdfFile.value = ''
      }
    },
    // Anexo oficial (chamado 20173): IMAGEM soma às do item; PDF é único e SUBSTITUI o que já
    // existe. Como a substituição destrói o arquivo antigo num bucket sem versionamento, o servidor
    // recusa o 2º PDF com PDF_JA_EXISTE_CONFIRMA_SUBSTITUICAO até o usuário confirmar; aí reenvia
    // com o flag. Sem este tratamento o upload virava no-op mudo.
    postarAnexoCop (node, file, confirmado) {
      const formData = new FormData()
      formData.append('file', file)
      if (confirmado) formData.append('confirmaSubstituicao', 'true')

      return COPOficialWorkModelRepository.PostCopFile(node.data.copModeloObra.id, node.data.copModeloItem.id, formData)
        .then(response => {
          const envelope = response.data || {}

          if (envelope.code !== 200) {
            if (!confirmado && envelope.message === 'PDF_JA_EXISTE_CONFIRMA_SUBSTITUICAO') {
              if (window.confirm('Este item já tem um PDF. O arquivo atual será sobrescrito e não poderá ser recuperado. Deseja substituir?')) {
                return this.postarAnexoCop(node, file, true)
              }
              return
            }
            toast.error(envelope.message || this.$lang.Common.Alerts.Error)
            return
          }

          const anexo = envelope.data
          const anexos = (node.data.anexos || []).slice()
          // Substituição devolve o MESMO id da linha reaproveitada — trocar no lugar, senão o
          // contador do grid duplica o anexo.
          const i = anexos.findIndex(a => a && a.id === anexo.id)
          if (i >= 0) anexos.splice(i, 1, anexo)
          else anexos.push(anexo)
          node.setDataValue('anexos', anexos)
          node.data.id = anexo.copModeloObraItemOfID
        })
        .catch(() => toast.error(this.$lang.Common.Alerts.Error))
    },
    toggleNa (params) {
      const na = !params.node.data.na

      if (params.node.data.copModeloItem.copItem.tipo === 1) {
        this.copOfServData[params.node.rowIndex].na = na
      } else {
        this.copOfDocData[params.node.rowIndex].na = na
      }

      this.copServGridOptions.api.refreshCells()
      this.copDocGridOptions.api.refreshCells()

      params.node.data.na = na
      this.onEdit(params.node)
    },
    getContextMenuItems (params) {
      return [
        {
          name: 'Inverter NA',
          icon: '<i class="fas fa-ban"></i>',
          action: () => this.toggleNa(params),
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_ADM)) ? 'd-none' : '']
        },
        'separator',
        {
          name: 'Adiciona Anexo',
          icon: '<i class="fas fa-upload"></i>',
          action: () => this.addFile(params),
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_ADM)) ? 'd-none' : '']
        },
        {
          name: 'Remove Anexo',
          icon: '<i class="fas fa-trash"></i>',
          action: () => this.removeFile(params),
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_ADM)) ? 'd-none' : '']
        }
      ]
    }
  },
  mounted () {
    this.copServColumnDefs = [
      {
        headerName: '',
        field: 'anexos',
        width: 15,
        minWidth: 15,
        onCellClicked: this.viewCopFile,
        cellRendererSelector: (params) => {
          return {
            component: 'FilesButton',
            params: {
              show: params.data.anexos.length && params.data.anexos.length > 0
            }
          }
        }
      },
      {
        headerName: 'Nr.',
        field: 'copModeloItem.posicao',
        width: 10,
        minWidth: 10
      },
      {
        headerName: this.$lang.PCI.COP.Services,
        valueGetter: params => {
          return params.data.copModeloItem.copItem.descricao
        },
        width: 150
      },
      {
        headerName: this.$lang.PCI.COP.Prev1,
        field: 'previsao1',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      },
      {
        headerName: this.$lang.PCI.COP.Goal,
        field: 'meta',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      },
      {
        headerName: this.$lang.PCI.COP.Prev2,
        field: 'previsao2',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      },
      {
        headerName: this.$lang.PCI.COP.Conclusion,
        field: 'conclusao',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      }
    ]

    this.copDocColumnDefs = [
      {
        headerName: '',
        field: 'anexos',
        width: 15,
        minWidth: 15,
        onCellClicked: this.viewCopFile,
        cellRendererSelector: (params) => {
          return {
            component: 'FilesButton',
            params: {
              show: params.data.anexos.length && params.data.anexos.length > 0
            }
          }
        }
      },
      {
        headerName: 'Nr.',
        field: 'copModeloItem.posicao',
        width: 10,
        minWidth: 10
      },
      {
        headerName: this.$lang.PCI.COP.Documents,
        valueGetter: params => {
          return params.data.copModeloItem.copItem.descricao
        },
        width: 150
      },
      {
        headerName: this.$lang.PCI.COP.Prev1,
        field: 'previsao1',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      },
      {
        headerName: this.$lang.PCI.COP.Goal,
        field: 'previsao2',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      },
      {
        headerName: this.$lang.PCI.COP.Prev2,
        field: 'previsao3',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      },
      {
        headerName: this.$lang.PCI.COP.Conclusion,
        field: 'conclusao',
        type: 'dateCopColumn',
        editable: this.hasRole(roles.RW_OPER_PCI_ADM),
        minWidth: 50,
        width: 50
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/cop/cop.js